import { ParentId } from './parentId';
import { generateTrackingIdentifier, TrackingIdentifier } from '../types/identifiers/trackingIdentifier';
import { ContentItemType, ItemType } from './ItemType';
import { PartialExcept } from '../utils/PartialExcept';
import { createGuid } from '../api/public/utils/Guid';

export type Item = {
  readonly id: string;
  readonly type: ItemType;
  readonly title?: string | undefined;
  readonly trackingIdentifier: TrackingIdentifier;
  readonly parentId: ParentId;
};

export const ItemHelper = {
  isContentItem: (item: Item): item is ContentItemType =>
    item.type !== ItemType.MenuItem &&
    item.type !== ItemType.NonSequencedFlow &&
    item.type !== ItemType.SequencedFlow &&
    item.type !== ItemType.Quiz &&
    item.type !== ItemType.ResourcesFolder,

  updateParentId: <T extends Item>(item: T, parentId: ParentId): T => ({ ...item, parentId }),

  build: ({ type, title, parentId, ...props }: PartialExcept<Item, 'type' | 'parentId'>): Item => ({
    type,
    id: props.id ?? createGuid(),
    parentId,
    trackingIdentifier: props.trackingIdentifier ?? generateTrackingIdentifier(),
    title,
  }),
};
